import { useTranslation } from 'react-i18next'


import { lazy, Suspense, useEffect, useMemo, useRef, useState } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { type NavigateFunction, useNavigate, useParams } from 'react-router-dom';

// import { ROLE_NAMES } from './enum';

import PermissionCustom from '../permission/PermissionCustom';
import i18n from '../../../../i18n';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import ContainerButton from '../../../../components/button/ContainerButton';
import { routeName } from '../../../../routes/routeName';
import StateComponents from '../../../../components/state-component/StateComponents';
import { RolesApi } from '../../../../api/roles/roles.api';
import { ProvinceAPI } from '../../../../api/province/province.api';
import { DistrictApi } from '../../../../api/district/district.api';
import { SubDistrictApi } from '../../../../api/sub-district/sub-district.api';
import { EmployeesCMSApi } from '../../../../api/employee-cms/employee.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertError, alertSuccess } from '../../../../components/alert/swal';
import ImageUpload from '../../../../components/image-upload/ImageUpload.component';
// import { debouncedApiCall } from '../../utils/app.utils';

type Props = {
    view?: boolean
}

const EmployeeAdd = ({ view }: Props) => {
    const dispatch = useDispatch();
    const uploadRef = useRef<any>(null)

    const { id } = useParams()

    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();
    const [form, setForm] = useState<any>({
        status: "active"
    });
    const [pathUrl, setPathUrl] = useState<string>("");

    const [file, set_file] = useState<any>();
    const [roles, setRoles] = useState<any[]>([]);
    const [province_data, setProVinceData] = useState<any[]>([]);
    const [district_data, setDistrictData] = useState<any[]>([]);
    const [sub_district_data, setSubDistrictData] = useState<any[]>([]);

    const handleGetProvince = async () => {
        await ProvinceAPI.GetProvince().then(res => {
            if (res.status < 300) {
                setProVinceData(res.data?.data || [])
            } else {
                setProVinceData([]);
            }
        }).catch((error) => console.log(error))
    }
    const handleGetDistrict = async (id?: any) => {
        if (id) {
            await DistrictApi.getDistrictByProvince(id).then(res => {
                if (res.status < 300) {
                    setDistrictData(res.data?.data || [])
                } else {
                    setDistrictData([]);
                }
            }).catch((error) => console.log(error))
        } else {
            await DistrictApi.getAllDistrict().then(res => {
                if (res.status < 300) {
                    setDistrictData(res.data?.data || [])
                } else {
                    setDistrictData([]);
                }
            }).catch((error) => console.log(error))
        }

    }
    const handleGetSubDistrict = async (id?: any) => {
        if (id) {
            await SubDistrictApi.getSubDistrictByDistrict(id).then(res => {
                if (res.status < 300) {
                    setSubDistrictData(res.data?.data || [])
                } else {
                    setSubDistrictData([]);
                }
            }).catch((error) => console.log(error));
        } else {
            await SubDistrictApi.getAllSubDistrict().then(res => {
                if (res.status < 300) {
                    setSubDistrictData(res.data?.data || [])
                } else {
                    setSubDistrictData([]);
                }
            }).catch((error) => console.log(error))
        }

    }
    const handleGetRoles = async () => {
        await RolesApi.getList().then((res) => {
            if (res.status < 300) {
                setRoles(res.data?.data || []);
            }
        }).catch((err) => {
            console.log(err)
        })
    }

    const getDetail = async () => {
        await EmployeesCMSApi.getDetailEmployee(id).then((res) => {
            if (res.status < 300) {
                setForm({ ...res.data?.data, ...res.data?.data?.employee_address });

            }
        }).catch((err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        handleGetRoles();
        handleGetProvince()
        handleGetDistrict()
        handleGetSubDistrict()
        if (id) {
            getDetail()
        }
    }, [])

    const handleAddEmployee = async () => {
        if (!form?.title) {
            return alertError(t('ระบุคำนำหน้า'))
        }
        if (!form?.first_name) {
            return alertError(t('ระบุชื่อ'))
        }
        if (!form?.last_name) {
            return alertError(t('ระบุนามสกุล'))
        }
        if (!form?.id_roles) {
            return alertError(t('ระบุบทบาท'))
        }
        if (!form?.email_personal) {
            return alertError(t('ระบุอีเมล'))
        }
        if (!form?.phone_number) {
            return alertError(t('ระบุเบอร์โทรศัพท์'))
        }

        if (!id && !form?.password) {
            return alertError(t('ระบุรหัสผ่าน'))
        }
        if (form?.password && (form?.password !== form?.c_password)) {
            return alertError(t('รหัสผ่านไม่ตรงกัน'))
        }
        if (form?.password && !form?.c_password) {
            return alertError(t('ระบุยืนยันรหัสผ่าน'))
        }
        const body = {
            ...form,
            c_password: undefined
        }
        dispatch(setLoading());
        if (id) {
            await EmployeesCMSApi.updateEmployee(id, body).then((res) => {
                if (res.status < 300) {
                    if (file) {
                        handleUploadPicture(file, id)
                    }
                    alertSuccess(t("แก้ไขบัญชีผู้ใช้เจ้าหน้าที่"), t("แก้ไขบัญชีผู้ใช้เจ้าหน้าที่ เรียบร้อย"));
                    navigate(routeName.cms_website.employee)
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขบัญชีผู้ใช้เจ้าหน้าที่"), t("แก้ไขบัญชีผู้ใช้เจ้าหน้าที่ ไม่สำเร็จ"))

            }).finally(() => {
                dispatch(unsetLoading());
            })

        } else {
            await EmployeesCMSApi.createEmployee(body).then((res) => {
                if (res.status < 300) {
                    if (file) {
                        handleUploadPicture(file, res.data.data?.id_employee)
                    }
                    alertSuccess(t("เพิ่มบัญชีผู้ใช้เจ้าหน้าที่"), t("เพิ่มบัญชีผู้ใช้เจ้าหน้าที่ เรียบร้อย"));
                    navigate(routeName.cms_website.employee)
                }
            }).catch((error) => {
                console.log(error)
                alertError(error?.response?.data?.message || t("เพิ่มบัญชีผู้ใช้เจ้าหน้าที่ ไม่สำเร็จ"))

            }).finally(() => {
                dispatch(unsetLoading());
            })
        }

    }
    const handleUploadPicture = async (file: File, id: any) => {
        await EmployeesCMSApi.pictureUpload(file, id).then((res) => {
            if (res.status < 300) {
                // setIdEmployeePicture(res.data?.data?.id_employee_picture)
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);

    // console.log(province_data?.find((x) => x?.province_name === form?.province));
    return (
        <div className='w-full'>
            <ContainerLayout
                // topRightContent={
                //     <></>
                // }
                // navigationList={
                //     <NavigateListCustom
                //         navigateData={[
                //             {
                //                 key: "HOME",
                //                 name: t("M.INFORMATION_SAP"),
                //                 pathName: RoutePath.home,
                //                 onClick: () => { }
                //             },
                //             {
                //                 key: "EMPLOYEE",
                //                 name: t("EMP.EMPLOYEE_INFORMATION"),
                //                 pathName: RoutePath.employee,
                //                 onClick: () => { }
                //             },
                //             {
                //                 key: "EMPLOYEE_ADD",
                //                 name: t("EMP.EMPLOYEE_ADD"),
                //                 pathName: RoutePath.employeeAdd,
                //                 onClick: () => { }
                //             },
                //         ]}
                //     />
                // }
                // disabledContainerMargin
                // filterPropsOther={{
                //     spacingFilter: 2,
                //     sx: {
                //         mt: 2
                //     }
                // }}
                // filterPropsContent={
                //     [
                //     ]
                // }
                title={id ? t('บัญชีผู้ใช้เจ้าหน้าที่') : t("เพิ่มบัญชีผู้ใช้เจ้าหน้าที่")}
                content={
                    <>
                        <section className='grid grid-cols-12'>
                            <span className="col-span-4">
                                <Typography variant='h5'>
                                    {t("ภาพพนักงาน")}
                                </Typography>
                                <div className='mt-4 pr-6'>
                                    <div style={{ display: "flex", justifyContent: "center" }}>
                                        <div style={{
                                            width: "200px",
                                            height: "200px",
                                            borderRadius: '50%',
                                            border: '5px solid #fff',
                                            boxShadow: 'rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px',
                                            // marginTop: "-100px",
                                            background: '#fff',
                                            // cursor: 'pointer',
                                            overflow: 'hidden'
                                        }} onClick={() => {
                                            // uploadRef?.current?.click()
                                        }}>
                                            <img src={file ? URL.createObjectURL(file) : id ? pathUrl + '/' + (form?.employee_file?.file_path?.includes('employee') ? form?.employee_file?.file_path + form?.employee_file?.file_name : form?.employee_file?.file_path) : 'https://placehold.co/600x400?text=No+Img'} style={{ width: '100%', height: "100%", objectFit: 'cover', objectPosition: 'center' }} />
                                        </div>
                                        <input type='file' accept="image/png, image/jpeg" ref={uploadRef} onChange={(obj: any) => set_file(obj.target.files[0])} style={{ display: 'none' }} />

                                    </div>
                                    {/* <ImageUpload imageUrl={id && pathUrl + '/' + (form?.employee_file?.file_path?.includes('employee') ? form?.employee_file?.file_path + form?.employee_file?.file_name : form?.employee_file?.file_path)} isUpload={true} onImageUpload={(file) => {
                                        set_file(file)
                                    }} /> */}
                                </div>
                            </span>
                            <div className="col-span-8">
                                <Typography variant='h6' sx={{ color: "#C8CCD6" }}>
                                    {t("ข้อมูลส่วนบุคคล")}
                                </Typography>
                                <Typography variant='h6'>
                                    {t("การแสดงผลชื่อ ณ ตอนสร้างข้อมูลข่าว")}
                                </Typography>
                                <div className='mt-4'>
                                    <StateComponents
                                        disabledAllField={view}
                                        otherProps={{ spacing: 2 }}
                                        typeProps={
                                            [
                                                {
                                                    seq: 1,
                                                    type: "SELECT",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        labelId: "select_title",
                                                        placeholder: t("ระบุคำนำหน้าชื่อ"),
                                                        heading: t("คำนำหน้าชื่อ"),
                                                        options: [
                                                            {
                                                                label: t("นาย"),
                                                                value: "นาย", // i18n-ignore
                                                            },
                                                            {
                                                                label: t("นาง"),
                                                                value: "นาง", // i18n-ignore
                                                            },
                                                            {
                                                                label: t("นางสาว"),
                                                                value: "นางสาว", // i18n-ignore
                                                            },
                                                        ],
                                                        selectId: "select-title",
                                                        onChange: (e) => {
                                                            setForm({ ...form, title: e.target.value })
                                                        },
                                                        value: form?.title || '',
                                                        required: true
                                                    }
                                                },
                                                {
                                                    seq: 2,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("ชื่อ"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, first_name: e.target.value })
                                                        },
                                                        value: form?.first_name,
                                                        required: true

                                                    }
                                                },
                                                {
                                                    seq: 3,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("นามสกุล"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, last_name: e.target.value })
                                                        },
                                                        value: form?.last_name,
                                                        required: true

                                                    }
                                                },
                                                {
                                                    seq: 4,
                                                    type: "AUTO-COMPLETE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        getOptionLabel: (op: any) => op?.roles_name || '',
                                                        labelId: "select_position",
                                                        placeholder: t("ระบุบทบาท"),
                                                        heading: t("บทบาท"),
                                                        onChange: (_: any, value: any) => {

                                                            if (value) {
                                                                setForm({ ...form, id_roles: value?.id_roles })

                                                            } else {
                                                                setForm({ ...form, id_roles: undefined })
                                                            }
                                                        },
                                                        options: roles || [],
                                                        value: roles?.find((x) => x?.id_roles === form?.id_roles) || null,
                                                        required: true

                                                    }
                                                },
                                                {
                                                    seq: 5,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("นามปากกา"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, buddhist_name: e.target.value })
                                                        },
                                                        value: form?.buddhist_name
                                                    }
                                                },
                                                {
                                                    seq: 6,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: !!id,
                                                        heading: t("อีเมล"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, email_organization: e.target.value })
                                                        },
                                                        value: form?.email_organization,
                                                        required: true

                                                    }
                                                },
                                                {
                                                    seq: 7,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("เบอร์โทรศัพท์"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, phone_number: e.target.value })
                                                        },
                                                        value: form?.phone_number,
                                                        required: true

                                                    }
                                                },

                                                {
                                                    seq: 8,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("รหัสผ่าน"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, password: e.target.value })
                                                        },
                                                        value: form?.password,
                                                        type: 'password',
                                                        required: !id

                                                    }
                                                },
                                                {
                                                    seq: 9,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 3
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("ยืนยันรหัสผ่าน"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, c_password: e.target.value })
                                                        },
                                                        value: form?.c_password,
                                                        type: 'password',
                                                        required: !id

                                                    }
                                                },

                                                {
                                                    seq: 10,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("บ้านเลขที่"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, house_number: e.target.value })
                                                        },
                                                        value: form?.house_number,
                                                    }
                                                },
                                                {
                                                    seq: 11,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("หมู่"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, moo: e.target.value })
                                                        },
                                                        value: form?.moo,
                                                    }
                                                },
                                                {
                                                    seq: 12,
                                                    type: "AUTO-COMPLETE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        getOptionLabel: (op: any) => op?.province_name,
                                                        labelId: "select_position",
                                                        placeholder: t("ระบุจังหวัด"),
                                                        heading: t("จังหวัด"),
                                                        onChange: (_: any, value: any) => {
                                                            if (value) {
                                                                setForm({ ...form, province: value?.province_name })
                                                                handleGetDistrict(value?.id_province)
                                                            } else {
                                                                setForm({ ...form, province: undefined })
                                                                setDistrictData([])
                                                            }
                                                        },
                                                        options: province_data || [],
                                                        value: province_data?.find((x) => x?.province_name === form?.province) || null
                                                    }
                                                },
                                                {
                                                    seq: 13,
                                                    type: "AUTO-COMPLETE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        getOptionLabel: (op: any) => op?.district_name,
                                                        labelId: "select_position",
                                                        placeholder: t("ระบุอำเภอ/เขต"),
                                                        heading: t("อำเภอ/เขต"),
                                                        onChange: (_: any, value: any) => {
                                                            if (value) {
                                                                setForm({ ...form, district: value?.district_name })
                                                                handleGetSubDistrict(value?.id_district)
                                                            } else {
                                                                setForm({ ...form, district: undefined })
                                                                setSubDistrictData([])
                                                            }
                                                        },
                                                        options: district_data || [],
                                                        value: district_data?.find((x) => x?.district_name === form?.district) || null
                                                    }
                                                },
                                                {
                                                    seq: 14,
                                                    type: "AUTO-COMPLETE",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        getOptionLabel: (op: any) => op?.district_sub_name,
                                                        labelId: "select_position",
                                                        placeholder: t("ระบุตำบล/แขวง"),
                                                        heading: t("ตำบล/แขวง"),
                                                        onChange: (_: any, value: any) => {

                                                            if (value) {
                                                                setForm({ ...form, district_sub: value?.district_sub_name })

                                                            } else {
                                                                setForm({ ...form, district_sub: undefined })
                                                            }
                                                        },
                                                        options: sub_district_data || [],
                                                        value: sub_district_data?.find((x) => x?.district_sub_name === form?.district_sub) || null
                                                    }
                                                },
                                                {
                                                    seq: 15,
                                                    type: "TEXT_FIELD",
                                                    gridProps: {
                                                        xs: 12,
                                                        md: 4
                                                    },
                                                    fieldProps: {
                                                        disabled: false,
                                                        heading: t("รหัสไปรษณีย์"),
                                                        onChange: (e) => {
                                                            setForm({ ...form, postcode: e.target.value })
                                                        },
                                                        value: form?.postcode,
                                                    }
                                                },
                                            ]}
                                    />
                                </div>

                            </div>
                        </section>
                        <ContainerButton
                            className='mt-6'
                            otherProps={{
                                spacing: 2
                            }}
                            buttonData={[
                                {
                                    key: "CANCEL",
                                    seq: 1,
                                    type: "CANCEL",
                                    label: t("BUTTON.CANCEL"),
                                    buttonProps: {
                                        onClick: () => {
                                            navigate(routeName.cms_website.employee)
                                        }
                                    }
                                },
                                {
                                    key: "CONFIRM",
                                    seq: 2,
                                    hidden: view,
                                    type: "CONFIRM",
                                    label: t("BUTTON.SUBMIT"),
                                    buttonProps: {
                                        onClick: () => {
                                            handleAddEmployee()
                                        }
                                    }
                                },
                            ]}
                        />
                    </>}
            />
        </div >
    )
}

export default EmployeeAdd